import styled from 'styled-components';
import Button from '@veneer/core/dist/scripts/button';
import { stylesIf, breakpoints } from '../utils/styleHelpers';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100vh - 25vw);
  max-width: 80vw;
  margin: 12.5vw auto;
  font-family: 'HP Simplified', Arial, sans-serif;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  @media screen and (min-width: 23.5rem) {
    justify-content: ${stylesIf('hasBody', 'space-evenly', 'center')};
  }
  @media screen and (min-width: 25.875rem) {
    justify-content: ${stylesIf('hasBody', 'space-between', 'space-evenly')};
    margin: 25vw auto;
    min-height: calc(100vh - 50vw);
  }
  @media screen and (min-width: 48rem) {
    min-height: calc(100vh - 60vw);
    margin-bottom: 35vw;
  }
  > * {
    margin: 0;
    padding: 16px 0;
    text-align: center;
    :first-child {
      padding-top: 0;
    }
    @media screen and (min-width: 25.875rem) {
      padding: 0;
    }
  }
  @media (min-width: 53.75rem) {
    font-size: 0.875rem;
    padding: 0 1rem;
    max-width: 100vw;
    min-height: calc(100vh - 20vh);
    margin-top: 2vh;
    margin-bottom: 0;
  }
`;

export const SureSupplyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100vh - 25vw);
  max-width: 80vw;
  margin: 12.5vw auto;
  font-family: 'HP Simplified', Arial, sans-serif;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  @media screen and (min-width: 23.5rem) {
    justify-content: ${stylesIf('hasBody', 'space-evenly', 'center')};
  }
  @media screen and (min-width: 25.875rem) {
    justify-content: ${stylesIf('hasBody', 'space-between', 'space-evenly')};
    margin: 25vw auto;
    min-height: calc(100vh - 50vw);
  }
  @media screen and (min-width: 48rem) {
    min-height: calc(100vh - 60vw);
    margin-bottom: 35vw;
  }
  > * {
    margin: 0;
    padding: 16px 0;
    text-align: unset;
    :first-child {
      padding-top: 0;
    }
    @media screen and (min-width: 25.875rem) {
      padding: 0;
    }
  }
  @media (min-width: 53.75rem) {
    font-size: 0.875rem;
    padding: 0 1rem;
    max-width: 100vw;
    min-height: calc(100vh - 20vh);
    margin-top: 15vh;
    margin-bottom: 0;
  }
`;

export const ReTargetContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  max-height: 100vh;
  min-height: auto;
  overflow-y: hidden;
  box-sizing: border-box;
  max-width: 90vw;
  padding-top: 7.5vw;
  padding-bottom: 0;
  margin: 0 5vw;
  font-family: 'HP Simplified', Arial, sans-serif;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  @media screen and (min-width: 23.5rem) {
    justify-content: ${stylesIf('hasBody', 'space-evenly', 'center')};
  }
  @media screen and (min-width: 25.875rem) {
    justify-content: ${stylesIf('hasBody', 'space-between', 'space-evenly')};
    margin: 0 auto;
  }
  @media screen and (min-width: 48rem) {
    overflow: hidden;
  }
  > * {
    margin: 0;
    padding: 16px 0;
    text-align: center;
    :first-child {
      padding-top: 0;
    }
  }
  @media (min-width: 53.75rem) {
    font-size: 0.875rem;
    padding: 4rem 1rem 0rem 0rem;
    max-width: 64rem;
  }
  }
  @media all and (-ms-high-contrast: active) and (max-width: 1100px),
    all and (-ms-high-contrast: none) and (max-width: 1100px) {
    padding-top: 5vw;
    margin-top: 0;
  }
`;

// This was added to fix the styling as per design
export const ReTargetContentContainer = styled.div`
  overflow: auto;
  padding: 0 5vw;
  text-align: ${(props) => props.isCompanyTenantPrinter ? 'left' : 'center'};
  @media screen and (max-width: ${breakpoints.tablet}) {
    overflow-y: auto;
    flex-grow: 0;
  }
  @media screen and (max-width: ${breakpoints.mobile}) {
    overflow-y: auto;
    max-height: ${(props) => (props.isDeclineAllButtonAppeared ? '64vh' : '68vh')};
  }
  @media all and (-ms-high-contrast: active) and (max-width: 1100px),
    all and (-ms-high-contrast: none) and (max-width: 1100px) {
    overflow-y: auto;
    max-height: 75vh;
  }
`;

export const Body = styled.div`
  &&&& {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (min-width: ${breakpoints.mobile}) {
      max-width: 44.5rem;
    }
    @media screen and (max-width: ${breakpoints.mobile}) {
      max-width: 34.5rem;
    }
    padding: 0;
    width: 100%;
    font-family: 'HP Simplified', Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.25;
    color: #4e4e4e;
    p,
    > span > p {
      margin: 1rem 0;
      > a {
        color: #027aae;
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const BodyList = styled.span`
  > ul {
    list-style: disc;
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    margin-left: ${(props) => (props.isRTL ? '0rem' : '2rem')};
    margin-right: ${(props) => (props.isRTL ? '2rem' : '0rem')};
  }
`;

export const BodySureSupply = styled.div`
  &&&& {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (min-width: ${breakpoints.mobile}) {
      max-width: 44.5rem;
    }
    @media screen and (max-width: ${breakpoints.mobile}) {
      max-width: 34.5rem;
    }
    padding: 0;
    text-align: center;
    width: 100%;
    font-family: 'HP Simplified', Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.25;
    color: #4e4e4e;
    p,
    > span > p {
      margin: 1rem 0;
      > a {
        color: #027aae;
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const ReTargetBody = styled.div`
  &&&& {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (min-width: ${breakpoints.tablet}) {
      max-width: 44.5rem;
    }
    @media screen and (max-width: ${breakpoints.tablet}) {
      max-width: 34.5rem;
    }
    padding: 0;
    width: 100%;
    font-family: 'HP Simplified', Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.25;
    color: #4e4e4e;
    p,
    > span > p {
      margin: 1rem 0;
      > a {
        color: #027aae;
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const Title = styled.h4`
  && {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    color: #313131;
    font-family: 'HP Simplified', Arial, sans-serif;
    line-height: 1.3;
    font-size: 1.25rem;
  }
`;

export const ReTargetButtonContainer = styled.div`
  display:flex;
  flex-direction:row-reverse;
  padding-bottom: ${(props) => (props.isDesktop ? '30px' : '10px')};
  // greater than or equal to 414 pixels
  @media screen and (min-width:${breakpoints.tablet}) {
    width:100%;
    margin-right: 0;
    &>button:not(:first-of-type) {
      margin-right:1rem;
    }
  }
  // less than or equal to 414 pixels
  @media screen and (max-width:${breakpoints.tablet}) {
    flex-direction:column;
    &>button:first-of-type {
      margin-left: 0;
      margin-bottom: 0.625rem;
    }
    &>button:last-of-type {
      margin-top: 0.625rem;
    }
  }

  @media screen and (min-width:500px) and (max-width:500px) and (min-height:530px ) and (max-height:530px) {
    width:100%;
    font-size: 1rem;
    line-height: 1.25rem;
    align-items: center;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    &>button:not(:first-of-type) {
      margin-right:1rem;
    }
    &>button:first-of-type {
      margin-bottom: 0;
    }
  }

  @media only screen and (min-width: 768px), (min-width: 1024px)
  and (max-width: 1024px), (max-width: 1366px)
  and (-webkit-min-pixel-ratio: 1), (-webkit-min-pixel-ratio: 2) {
    /* iPad and iPadPro only with Desktop exception */
    flex-direction: ${(props) => (props.isDesktop ? 'row-reverse' : 'column')};
    width: ${(props) => (props.isDesktop ? '100%' : 'auto')};
    margin-right: 0;
    &>button:first-of-type {
      margin-left: 0;
      margin-bottom: ${(props) => (props.isDesktop ? '0' : '0.625rem')};
      margin-right: ${(props) => (props.isDesktop && props.isRTL ? '1rem' : '0')};
    }
    &>button:last-of-type {
      align-items: center;
      margin-top:${(props) => (props.isDesktop ? '0' : '0.625rem')};
    }
    &>button:not(:first-of-type) {
      margin-right:${(props) => (props.isDesktop ? '1rem' : '0')};
    }
  }

  @media all and (-ms-high-contrast: active) and (max-width: 1100px), all and (-ms-high-contrast: none) and (max-width: 1100px) {
    margin-top: 10px;
  }

}
`;
export const StyledButton = styled(Button)`
  && {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      font-weight: bold;
    }
    min-height: ${stylesIf('small', '2.25', '2.875')}rem;
    ${stylesIf('small', 'border-radius: 0.5rem;')}
    ${stylesIf(
      'hasBody',
      `
        @media screen and (min-width: 25.875rem) {
          margin-top: 1rem;
        }
      `
    )}
  }
`;

export const Graphic = styled.img`
  @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
    margin-left: 50%;
    transform: translate(-50%);
  }
  height: ${(props) => (props.isWJA ? '3.25rem' : '6.25rem')};
  width: auto;
`;

export const LogoContainer = styled.div`
  text-align: center;
  padding: 1rem;
`;
export const ToggleLayout = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  max-width: 34.5rem;
  justify-content: center;
  margin: 1rem auto;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 100%;
  }
  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    line-height: 1.25rem;
    font-size: 1rem;
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    max-width: ${(props) => (props.isDesktop ? '100%' : '34.5rem')};
  }
`;
